'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssComponent = require('react-css-component');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = '\n  .Loader,\n  .Loader:before,\n  .Loader:after {\n    border-radius: 50%;\n  }\n  .Loader {\n    color: #00B9F7;\n    font-size: 11px;\n    text-indent: -99999em;\n    margin: 55px auto;\n    position: relative;\n    width: 10em;\n    height: 10em;\n    box-shadow: inset 0 0 0 1em;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n  .Loader:before,\n  .Loader:after {\n    position: absolute;\n    content: \'\';\n  }\n  .Loader:before {\n    width: 5.2em;\n    height: 10.2em;\n    border-radius: 10.2em 0 0 10.2em;\n    top: -0.1em;\n    left: -0.1em;\n    -webkit-transform-origin: 5.2em 5.1em;\n    transform-origin: 5.2em 5.1em;\n    -webkit-animation: load2 2s infinite ease 1.5s;\n    animation: load2 2s infinite ease 1.5s;\n  }\n  .Loader:after {\n    width: 5.2em;\n    height: 10.2em;\n    border-radius: 0 10.2em 10.2em 0;\n    top: -0.1em;\n    left: 5.1em;\n    -webkit-transform-origin: 0px 5.1em;\n    transform-origin: 0px 5.1em;\n    -webkit-animation: load2 2s infinite ease;\n    animation: load2 2s infinite ease;\n  }\n  .Loader-white:before {background: #fff;}\n  .Loader-white:after {background: #fff;}\n  .Loader-lightGray:before {background: #f6f6f6;}\n  .Loader-lightGray:after {background: #f6f6f6;}\n  @-webkit-keyframes load2 {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n  @keyframes load2 {\n    0% {\n      -webkit-transform: rotate(0deg);\n      transform: rotate(0deg);\n    }\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n';

// header

var Spinner = function Spinner(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_reactCssComponent.UniversalStyle, { css: css }),
    _react2.default.createElement(
      'div',
      { className: props.spinnerBgcolor === 'white' ? 'Loader Loader-white' : 'Loader Loader-lightGray' },
      'Loading...'
    )
  );
};

exports.default = Spinner;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/UI/Spinner.js
// module id = 798
// module chunks = 0